// extracted by mini-css-extract-plugin
module.exports = {"table":"FieldsTable_table__3L2oH","tableHeadCell":"FieldsTable_tableHeadCell__2fg15"};